import { render, staticRenderFns } from "./merchantSettlement.vue?vue&type=template&id=22605805&scoped=true"
import script from "./merchantSettlement.vue?vue&type=script&lang=js"
export * from "./merchantSettlement.vue?vue&type=script&lang=js"
import style0 from "./merchantSettlement.vue?vue&type=style&index=0&id=22605805&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22605805",
  null
  
)

export default component.exports